import React from 'react';

const items = [
  'Mic Technique',
  'Narrative Structure',
  'RSS Plumbing',
  'Sponsorship Math',
  'Guest Booking',
  'Edit Workflow',
  'Show Notes',
  'Dynamic Ads',
  'Audience Building',
  'Interview Craft',
];

const MarqueeBar: React.FC = () => {
  const doubled = [...items, ...items];

  return (
    <div
      className="overflow-hidden py-4 border-y"
      style={{
        borderColor: 'var(--color-cream-border)',
        background: 'var(--color-parchment-dark)',
      }}
    >
      <div className="marquee-track whitespace-nowrap">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-4 mx-6"
          >
            <span
              className="font-display italic text-sm font-light"
              style={{ color: 'var(--color-charcoal-light)' }}
            >
              {item}
            </span>
            <span style={{ color: 'var(--color-brass)', fontSize: '0.5rem' }}>
              ◆
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeBar;